module.exports = __webpack_public_path__ + "static/img/huwaiyundong.3ec8b2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/huwaiyundong.png
// module id = TgOW
// module chunks = 0